import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  cancelSubscription,
  clearCancelSubscription,
  renewSubscription,
  clearRenewSubscription,
  fetchCreditCardInfo,
  clearFetchCreditCardInfo,
} from 'redux/billing/actions';
import { fetchMe } from 'redux/users/actions';

import { Link } from 'react-router-dom';

import { Elements as StripeElements } from 'react-stripe-elements';
import { Loader } from 'semantic-ui-react';

import UpdateCreditCardForm from 'components/dashboard/billing-content/UpdateCreditCardForm';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';
import FixedNotification from 'components/common/FixedNotification';
import DowngradePlanModal from 'components/dashboard/billing-content/DowngradePlanModal';

import './YourCurrentPlanContent.css';

class YourCurrentPlanContent extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    cancelSubscription: PropTypes.func.isRequired,
    clearCancelSubscription: PropTypes.func.isRequired,
    renewSubscription: PropTypes.func.isRequired,
    clearRenewSubscription: PropTypes.func.isRequired,
    fetchCreditCardInfo: PropTypes.func.isRequired,
    clearFetchCreditCardInfo: PropTypes.func.isRequired,
    me: PropTypes.object,
    proPlan: PropTypes.object.isRequired,
    subscriptionCancelled: PropTypes.object,
    subscriptionCancelledError: PropTypes.object,
    subscriptionRenewed: PropTypes.object,
    subscriptionRenewedError: PropTypes.object,
    creditCardInfo: PropTypes.object,
    creditCardInfoError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    subscriptionCancelled: null,
    subscriptionCancelledError: null,
    subscriptionRenewed: null,
    subscriptionRenewedError: null,
    creditCardInfo: null,
    creditCardInfoError: null,
  };

  state = {
    updateCreditCard: false,
    cancelNotification: false,
    renewNotification: false,
    downgradeModalOpen: false,
    paymentMethod: this.props.me.subscription.payment_method,
  };

  componentDidMount() {
    if (this.props.me.subscription.payment_method === 'stripe') {
      this.props.fetchCreditCardInfo();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.subscriptionCancelled && this.props.subscriptionCancelled) {
      this.setState({
        cancelNotification: true,
        downgradeModalOpen: false,
      });
      this.props.fetchMe();
      this.props.clearCancelSubscription();
    }

    if (!prevProps.subscriptionRenewed && this.props.subscriptionRenewed) {
      this.setState({ renewNotification: true });
      this.props.fetchMe();
      this.props.clearRenewSubscription();
    }
  }

  componentWillUnmount() {
    this.props.clearCancelSubscription();
    this.props.clearRenewSubscription();
    this.props.clearFetchCreditCardInfo();
    this.setState({ updateCreditCard: false });
  }

  _cancelSubscription = () => {
    this.props.cancelSubscription(this.state.paymentMethod);
  };

  _renewSubscription = () => {
    this.props.renewSubscription(this.props.proPlan.id, this.state.paymentMethod);
  };

  _setUpdateCreditCard = value => {
    this.setState({ updateCreditCard: value });
  };

  render() {
    const {
      me,
      creditCardInfo,
      subscriptionCancelledError,
      subscriptionRenewedError,
      creditCardInfoError,
    } = this.props;

    const {
      updateCreditCard,
      cancelNotification,
      renewNotification,
      downgradeModalOpen,
      paymentMethod,
    } = this.state;

    if (!me.subscription) return null;

    const currentBillingPlan = me.subscription.billing_plan;
    const isPlanCancelled = me.subscription && me.subscription.canceled;

    return (
      <Translation>
        {(t) => (
          <div className="your-current-plan-content__component">
            <div className="title">
              {t("Your current plan:")} <span>PRO</span>
            </div>

            <div className="plan-price">
              <span>${currentBillingPlan.value} USD</span> / {currentBillingPlan.interval}
            </div>

            <div className="subtext">
              {t("You have access to all PRO features. " +
                 "Thank you for your support!")}
            </div>

            <div className="cancel-renew-block">
              {!isPlanCancelled ?
                <div
                  className="action-button downgrade-free"
                  onClick={() => this.setState({ downgradeModalOpen: true }) }
                  role="button"
                  tabIndex={-1}
                >
                  {t("Downgrade to Free")}
                </div>
                :
                <div
                  className="action-button"
                  onClick={this._renewSubscription}
                  role="button"
                  tabIndex={-1}
                >
                  {t("Renew Subscription")}
                </div>
              }
            </div>

            {/*Credit Card Info*/}
            {paymentMethod === 'stripe' &&
              !creditCardInfoError &&
              !updateCreditCard &&
              <div className="credit-card-block">
                {creditCardInfo ?
                  <Fragment>
                    <div className="credit-card-info">
                      <div className="card-icon" />
                      <div className="card-number">**** **** **** {creditCardInfo.last4}</div>
                      <div>{creditCardInfo.exp_month} / {creditCardInfo.exp_year}</div>
                    </div>

                    <div className="buttons-block">
                      <Button
                        borderedBlue
                        onClick={() => this._setUpdateCreditCard(true) }
                      >
                        {t("Update Credit Card")}
                      </Button>
                    </div>

                    <Link
                      className="billing-details-link"
                      to="/billing/details"
                    >
                      {t("Billing Details & Invoices")}
                    </Link>

                  </Fragment>
                  :
                  <Loader active />
                }
              </div>
            }

            {paymentMethod === 'paypal' &&
              <Link
                className="billing-details-link"
                to="/billing/details"
              >
                {t("Billing Details & Invoices")}
              </Link>
            }

            {/* Update Credit Card Form */}
            {updateCreditCard &&
              <div className="update-credit-card-form">
                <StripeElements>
                  <UpdateCreditCardForm
                    setUpdateCreditCard={this._setUpdateCreditCard}
                  />
                </StripeElements>
              </div>
            }

            {/* Errors */}
            <div className="errors-block">
              {subscriptionCancelledError &&
                <CommonMessage
                  error
                  errors={subscriptionCancelledError}
                />
              }

              {subscriptionRenewedError &&
                <CommonMessage
                  error
                  errors={subscriptionRenewedError}
                />
              }

              {creditCardInfoError &&
                <CommonMessage error>
                  {creditCardInfoError}
                </CommonMessage>
              }
            </div>

            {/* Notifications */}
            {cancelNotification &&
              <FixedNotification
                fullscreen
                onFadeComplete={() => this.setState({ cancelNotification: false }) }
              >
                {t("Your account was downgraded to STARTER")}
              </FixedNotification>
            }

            {renewNotification &&
              <FixedNotification
                fullscreen
                onFadeComplete={() => this.setState({ renewNotification: false }) }
              >
                {t("Your account was renewed to PRO")}
              </FixedNotification>
            }

            {/* Downgrade Modal */}
            <DowngradePlanModal
              open={downgradeModalOpen}
              onClose={() => this.setState({ downgradeModalOpen: false }) }
              onDowngrade={this._cancelSubscription}
            />

          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    subscriptionCancelled: state.billingReducer.subscriptionCancelled,
    subscriptionCancelledError: state.billingReducer.subscriptionCancelledError,
    subscriptionRenewed: state.billingReducer.subscriptionRenewed,
    subscriptionRenewedError: state.billingReducer.subscriptionRenewedError,
    creditCardInfo: state.billingReducer.creditCardInfo,
    creditCardInfoError: state.billingReducer.creditCardInfoError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    cancelSubscription,
    clearCancelSubscription,
    renewSubscription,
    clearRenewSubscription,
    fetchCreditCardInfo,
    clearFetchCreditCardInfo,
  },
)(YourCurrentPlanContent);
